import React from 'react';
import GameAnalyticsContainer from './GameAnalyticsContainer';

const GameAnalyticsView = () => {
  return <GameAnalyticsContainer />;
};

export default GameAnalyticsView;
